<template>
  <v-row no-gutters class="tab-item">
    <v-col v-if="!loading" class="pa-4">
      <template v-if="!websites.length > 0 || !competitionWebsites.length > 0">
        <NoDataInfo
          v-if="!websites.length > 0"
          :title="$t('message.competition.visibility.nodata.title')"
          :description="$t('message.competition.visibility.nodata.content')"
          :buttonName="$t('message.common.newWebsite')"
          buttonRouteName="profile-websites"
        />
        <NoDataInfo
          v-if="!competitionWebsites.length > 0"
          title="Brak adresu strony www konkurencji"
          description="Dodaj adresy stron www konkurencji"
          :buttonName="$t('message.common.newWebsite')"
          buttonRouteName="competition-websites"
        />
      </template>

      <template v-if="websites.length > 0 && competitionWebsites.length > 0">
        <v-row>
          <v-col cols="12" lg="8">
            <v-select
              :items="websites"
              :label="$t('message.competition.label.yourWebsiteAddress')"
              item-text="url"
              item-value="url"
              return-object
              v-model="selectedWebsite"
              @input="getKeywordDataOnInput"
              style="height: auto"
              :loading="loadingKeywordData"
            ></v-select>
            <v-select
              :items="selectedWebsite.search_locations"
              :label="$t('message.competition.label.localization')"
              item-text="name"
              item-value="id"
              return-object
              @input="getKeywordDataOnInput"
              v-model="selectedLocation"
              style="height: auto"
              :loading="loadingKeywordData"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="4">
            <v-select
              :items="competitionWebsites"
              :label="$t('message.competition.label.competitionWebsiteAddress')"
              item-text="url"
              item-value="url"
              return-object
              @input="getKeywordDataOnInput"
              v-model="selectedCompetitionWebsite"
              style="height: auto"
              :loading="loadingKeywordData"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="8" style="position: relative;">
            <template
              v-if="
                selectedKeywordData.data &&
                  selectedKeywordData.data.length > 0 &&
                  selectedKeywordData.labels &&
                  selectedKeywordData.labels.length > 0
              "
            >
              <div class="d-flex justify-center mb-5">
                <span class="legend-item--yourFirm">{{
                  $t("message.common.yourCompany")
                }}</span>
                <span class="legend-item--competition">{{
                  $t("message.common.competition")
                }}</span>
              </div>
              <Chart
                :width="370"
                :height="500"
                :data="selectedKeywordData.data"
                :labels="selectedKeywordData.labels"
                :loading="loadingKeywordData"
                @loadingChartStatus="loadingKeywordData = $event.value"
              />
            </template>
            <template v-else>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center flex-column"
                  style="height: 500px;"
                >
                  <v-icon x-large class="ma-2" color="primary">
                    mdi-database-search
                  </v-icon>
                  <h3>{{ $t("message.common.noData") }}</h3>
                </v-col>
              </v-row>
            </template>
            <ChartPagination
              @changeMonth="changeMonth"
              :currentMonth="currentMonth"
            />
            <SectionLoader :status="loadingKeywordData" />
          </v-col>
          <v-col lg="4" style="position: relative;">
            <KeywordList
              :hasAddButton="false"
              :minHeight="550"
              :selectedId.sync="selectedKeywordId"
              :items="selectedLocationKeywords"
              :loading="loadingKeywordData"
              @update:selectedId="getKeywordDataOnClick"
              @loadingKeywords="loadingKeywordData = $event.value"
            />
          </v-col>
        </v-row>
      </template>
    </v-col>
    <SectionLoader :status="loading" />
  </v-row>
</template>

<script>
import NoDataInfo from "@/components/Visibility/NoDataInfo.vue";
import KeywordList from "@/components/Visibility/KeywordList.vue";
import Chart from "@/components/Competition/Websites/Chart.js";
import ChartPagination from "@/components/Chart/Pagination.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import websitesService from "@/services/websites";
import competitionService from "@/services/competition";
import serviceHandler from "@/helpers/handlers/service";

import { mapState } from "vuex";

import moment from "moment";

export default {
  name: "CompetitionWebsitesHOC",
  components: {
    NoDataInfo,
    KeywordList,
    Chart,
    ChartPagination,
    SectionLoader
  },
  data() {
    return {
      loading: false,
      loadingKeywordData: false,
      currentMonth: {},
      websites: [],
      selectedWebsite: {},
      selectedLocation: {},
      selectedLocationKeywords: [],
      competitionWebsites: [],
      selectedCompetitionWebsite: {},
      selectedKeywordId: null,
      selectedKeywordData: []
    };
  },

  computed: {
    ...mapState({
      companyId: state => state.company.id
    })
  },

  async created() {
    this.loading = true;
    await this.getCurrentMonth();
    await this.fetchWebsites();
    if (this.websites.length > 0) {
      await this.selectWebsite();
      await this.selectLocation();
      await this.fetchLocationKeywords();
      this.selectedKeywordId = this.selectedLocationKeywords[0].id;
    }
    await this.fetchCompetitionWebsites();
    if (this.competitionWebsites.length > 0) {
      await this.selectCompetitionWebsite();
    }
    if (this.websites.length > 0 && this.competitionWebsites.length > 0) {
      await this.getKeywordData();
    }
    this.loading = false;
  },

  methods: {
    async changeMonth(val) {
      await this.getCurrentMonth(val);
      this.emitFromTo(val);
    },

    emitFromTo(val) {
      const payload = {
        from: moment(val)
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment(val)
          .endOf("month")
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      this.getKeywordData();
    },
    formatKeywordData(data) {
      const formatted = {
        labels: [],
        data: []
      };

      const labels = data.website.map(item => item.searched_at);

      formatted.labels.push(...labels);
      const websiteData = Object.values(data).map(website =>
        website.map(item => item.position_organic)
      );

      formatted.data.push(...websiteData);

      return formatted;
    },

    getCurrentMonth(month) {
      month = month || moment();
      this.currentMonth = month;
    },

    async fetchWebsites() {
      this.websites = await serviceHandler(websitesService.getWebsitesData());
    },

    selectWebsite(id) {
      this.selectedWebsite = !id
        ? this.websites[0]
        : this.websites.find(website => website.id === id);
    },

    selectLocation(id) {
      this.selectedLocation = !id
        ? this.selectedWebsite.search_locations[0]
        : this.selectedWebsite.search_locations.find(
            location => location.id === id
          );
    },

    async fetchLocationKeywords() {
      const websiteId = this.selectedWebsite.id;
      const locationId = this.selectedLocation.id;

      const data = await serviceHandler(
        websitesService.getKeywordsByLocation(websiteId, locationId)
      );

      if (data.length > 0) {
        this.selectedLocationKeywords = data[0].keywords;
      }
    },

    async fetchCompetitionWebsites() {
      this.competitionWebsites = await serviceHandler(
        competitionService.getCompetitionWebsites(this.companyId)
      );
    },

    selectCompetitionWebsite(id) {
      this.selectedCompetitionWebsite = !id
        ? this.competitionWebsites[0]
        : this.competitionWebsites.find(website => website.id === id);
    },

    getKeywordDataOnClick(keywordId) {
      this.getKeywordData(keywordId);
    },

    getKeywordDataOnInput() {
      this.fetchLocationKeywords();
      this.getKeywordData();
    },

    async getKeywordData(keywordId) {
      keywordId =
        keywordId ||
        this.selectedKeywordId ||
        this.selectedLocationKeywords[0].id;

      this.loadingKeywordData = true;

      const locationId = this.selectedLocation.id;

      const date = {
        from: moment(this.currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment(this.currentMonth)
          .endOf("month")
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      const data = await serviceHandler(
        websitesService.getCompetitionOrganicSearchData(
          {
            competitionWebsiteId: this.selectedCompetitionWebsite.id,
            websiteId: this.selectedWebsite.id,
            locationId,
            keywordId: keywordId
          },
          date
        )
      );

      this.selectedKeywordData = this.formatKeywordData(data);
      this.loadingKeywordData = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-item {
  min-height: 800px;
  position: relative;
}

.legend-item--competition {
  color: rgba($dark, 0.9);
  position: relative;
  margin: 0 24px;

  &::before {
    content: "";
    width: 7px;
    max-width: 7px;
    height: 7px;
    background: $orange;
    border-radius: 10px;
    position: absolute;
    display: block;
    left: -16px;
    top: 8px;
  }
}

.legend-item--yourFirm {
  color: rgba($dark, 0.9);
  position: relative;
  margin: 0 24px;

  &::before {
    content: "";
    width: 7px;
    max-width: 7px;
    height: 7px;
    background: $primary;
    border-radius: 10px;
    position: absolute;
    display: block;
    left: -16px;
    top: 8px;
  }
}
</style>
